import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import LocationPage from "./pages/LocationPage";
import LegalPage from "./pages/LegalPage";
import ServicePage from "./pages/ServicePage";
import BusinessPage from "./pages/BusinessPage";
import PricingPage from "./pages/PricingPage";
import MobileCTABar from "./components/MobileCTABar";
import Analytics from "./components/Analytics";
import CookieConsent from "./components/CookieConsent";
import { locations } from "./data/locations";
import { services } from "./data/services";

const LEGAL_SLUGS = ["algemene-voorwaarden", "privacybeleid", "cookieverklaring"];

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <ScrollToTop />
        <Header />
        <main role="main">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/zakelijk" element={<BusinessPage />} />
            <Route path="/kosten-glazenwasser" element={<PricingPage />} />
            {services.map((s) => (
              <Route key={s.slug} path={`/${s.slug}`} element={<ServicePage slug={s.slug} />} />
            ))}
            {locations.map((loc) => (
              <Route
                key={loc.slug}
                path={`/glazenwasser-${loc.slug}`}
                element={<LocationPage slug={loc.slug} />}
              />
            ))}
            {LEGAL_SLUGS.map((slug) => (
              <Route key={slug} path={`/${slug}`} element={<LegalPage slug={slug} />} />
            ))}
            <Route path="*" element={<HomePage />} />
          </Routes>
        </main>
        <Footer />
        {/* Spacer so the sticky mobile CTA bar never permanently covers footer content */}
        <div aria-hidden="true" className="h-16 md:hidden" />
        <MobileCTABar />
        <Analytics />
        <CookieConsent />
        <Toaster position="top-right" />
      </div>
    </BrowserRouter>
  );
}

export default App;
